import style from "../style.scss";

import { useState, useRef, useEffect } from "preact/hooks";
import MatchLink from "../../../link/match";
import IconDown from "../../../icons/down";
import namedRoutes from "../../../../settings/routes";
import { mergeClasses } from "../../../helpers";

const SubMenu = () => {
  const [menuActive, setMenuActive] = useState(false);
  const navRef = useRef(null);

  const handleToggle = () => {
    setMenuActive(!menuActive);
  };

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      // Close the menu if clicked outside
      setMenuActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <li
      class={mergeClasses([
        style.subMenu,
        menuActive ? style.subMenuActive : null,
      ])}
      role="menuitem"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <button
        class={style.subMenuToggleButton}
        aria-label="Toggle submenu"
        onClick={handleToggle}
        ref={navRef}
      >
        <span class={style.buttonText}>More</span>
        <span class={style.buttonIcon}>
          <IconDown open={menuActive} />
        </span>
      </button>

      <ul class={style.subMenuItems} role="menu" aria-label="Submenu">
        {/* <li role="menuitem">
          <MatchLink activeClass={style.current} href="/todo">
            Power System Types
          </MatchLink>
        </li> */}
        <li role="menuitem">
          <MatchLink
            activeClass={style.current}
            href={namedRoutes.alternatorChargers}
          >
            Alternator Chargers
          </MatchLink>
        </li>
        <li role="menuitem">
          <MatchLink
            activeClass={style.current}
            href={namedRoutes.powerSystems}
          >
            Power Systems
          </MatchLink>
        </li>
        <li role="menuitem">
          <MatchLink
            activeClass={style.current}
            href={namedRoutes.ecoflow.vanlife}
          >
            EcoFlow
          </MatchLink>
        </li>
        <li role="menuitem">
          <MatchLink
            activeClass={style.current}
            href={namedRoutes.bluetti.vanlife}
          >
            BLUETTI
          </MatchLink>
        </li>
        <li role="menuitem">
          <MatchLink
            activeClass={style.current}
            href={namedRoutes.jackery.vanlife}
          >
            Jackery
          </MatchLink>
        </li>
        <li role="menuitem">
          <MatchLink activeClass={style.current} href={namedRoutes.deals}>
            Coupons & Deals
          </MatchLink>
        </li>
        <li role="menuitem">
          <MatchLink
            activeClass={style.current}
            href={namedRoutes.inventory.vanlife}
          >
            My Vanlife Build
          </MatchLink>
        </li>
        <li role="menuitem">
          <MatchLink activeClass={style.current} href={namedRoutes.about}>
            About Me
          </MatchLink>
        </li>
      </ul>
    </li>
  );
};

export default SubMenu;
